import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Link, Redirect } from 'react-router-dom';
import Axios from 'axios';
import queryString from 'query-string';
import { Container, Row, Col, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { StyleRoot } from 'radium';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import Loader from 'react-loader-spinner';

import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import HomepageList from './components/HomepageList';
import StatusList from './components/StatusList';
import ElectionList from './components/ElectionList';
import ResultsList from './components/ResultsList';
import MyLoader from './components/MyLoader';
import LinkModal from './components/LinkModal';
import LeaveLegend from './components/LeaveLegend';
import Statements from './components/Statements';

const GOOGLE_AUTH_CLIENT_ID =
	'954440460815-1auniiqm2svccjt953bu4jglk2hmgt2a.apps.googleusercontent.com';

class App extends Component {
	state = {
		email: '',
		leave: {},
		nominations: {},
		elections: {},
		finished: {},
		groups: [],
		ballot: {},
		choices: [],
		results: {},
		type: '',
		id: '',
		statusTitle: '',
		ballotTitle: '',
		resultsTitle: '',
		divTitle: '',
		audience_id: '',
		offline: false,
		homeLoaded: 0,
		isLoaded: true,
		ballotLoaded: 2,
		isLoggedIn: false,
	};

	setAccessToken = (token) => {
		this.setState({ accessToken: token });
	};

	setGroups = (groups) => {
		this.setState({ groups: groups });
	};

	setBallot = (ballot) => {
		this.setState({ ballot: ballot });
	};

	clearBallot = () => {
		this.setState({ ballot: {} });
	};

	setChoices = (choices) => {
		this.setState({ choices: choices });
	};

	clearChoices = () => {
		this.setState({ choices: [] });
	};

	setResults = (results) => {
		this.setState({ results: results });
	};

	setType = (type) => {
		this.setState({ type: type });
	};

	setId = (id) => {
		this.setState({ id: id });
	};

	setResultsTitle = (title) => {
		this.setState({ resultsTitle: title });
	};

	setStatusTitle = (title) => {
		this.setState({ statusTitle: title });
	};

	setBallotTitle = (title) => {
		this.setState({ ballotTitle: title });
	};

	setDivTitle = (title) => {
		this.setState({ divTitle: title });
	};

	setAudience_id = (id) => {
		this.setState({ audience_id: id });
	};

	setOffline = (offline) => {
		this.setState({ offline: offline });
	};

	setEmail = (email) => {
		this.setState({ email: email });
	};

	setLeave = (leave) => {
		this.setState({ leave: leave });
	};

	setIsLoaded = (loaded) => {
		this.setState({ isLoaded: loaded });
	};

	setIsLoggedIn = (logged) => {
		this.setState({ isLoggedIn: logged });
	};

	addBallotLoaded = () => {
		this.setState({ ballotLoaded: this.state.ballotLoaded + 1 });
	};

	clearBallotLoaded = () => {
		this.setState({ ballotLoaded: 0 });
	};

	markChoice = (id) => {
		var currentBallot = this.state.ballot;
		currentBallot.candidates = currentBallot.candidates.map((candidate) => {
			if (candidate.id === id) {
				candidate.selected = !candidate.selected;
				if (candidate.selected) {
					currentBallot.number_selected += 1;
				} else {
					currentBallot.number_selected -= 1;
				}
			}
			return candidate;
		});
		this.setState({
			ballot: currentBallot,
		});
		this.checkChoices();
	};

	checkChoices = () => {
		if (!(this.state.ballot.candidates === undefined)) {
			var currentChoices = [];
			this.state.ballot.candidates.forEach((candidate) => {
				if (candidate.selected) {
					currentChoices.push(candidate);
				}
				if (currentChoices !== this.state.choices) {
					this.setState({
						choices: currentChoices,
					});
				}
			});
		}
	};

	initializeChoices = () => {
		if (!(this.state.ballot.candidates === undefined) && this.state.choices.length === 0) {
			var initChoices = [];
			this.state.ballot.candidates.forEach((candidate) => {
				if (candidate.selected) {
					initChoices.push(candidate);
				}
			});
			this.setState({
				choices: initChoices,
			});
		}
	};

	saveChoices = async () => {
		this.setIsLoaded(false);
		if (this.state.ballot.number_selected > this.state.ballot.number_to_select) {
			return false;
		} else {
			var choiceArr = [];
			this.state.choices.forEach((candidate) => {
				choiceArr.push({
					id: candidate.id,
				});
			});
			const Body = {
				email: this.state.email,
				audience_id: this.state.audience_id,
				division: this.state.divTitle,
				selections: choiceArr,
			};
			const nomURL = 'https://hcapps.holycross.edu/faculty_elections_admin/update_nominations';
			const eleURL = 'https://hcapps.holycross.edu/faculty_elections_admin/update_votes';
			var path = '';
			if (this.state.ballot.type === 'nomination') {
				path = nomURL;
			}
			if (this.state.ballot.type === 'election') {
				path = eleURL;
			}
			await Axios({
				method: 'post',
				url: path,
				timeout: 5000,
				headers: { AUTHKEY: sessionStorage.getItem('FECaccessToken') },
				data: Body,
			})
				.then((res) => {
					console.log('choices saved to current election');
					this.setOffline(false);
					if (res.data.result === 'failure') {
						alert('Something went wrong with your ballot: ' + res.data.message);
					}
				})
				.catch((error) => {
					console.error('error saving choices to current election: ', error);
					this.setOffline(true);
				});
			if (this.state.type === 'nomination') {
				const url =
					'https://hcapps.holycross.edu/faculty_elections_admin/available_nominations?';
				const args = {
					election_id: this.state.id,
					email: this.state.email,
				};
				const query = queryString.stringify(args, { encode: false });
				const path = url + query;
				Axios({
					method: 'get',
					url: path,
					timeout: 5000,
					headers: { AUTHKEY: sessionStorage.getItem('FECaccessToken') },
				})
					.then((res) => {
						console.log('successfully queried nomination divisions');
						this.setGroups(res.data);
						sessionStorage.setItem('FECstatusList', JSON.stringify(res.data));
						this.setOffline(false);
						this.setIsLoaded(true);
					})
					.catch((error) => {
						console.error('error querying nomination divisions: ', error);
						this.setOffline(true);
					});
			} else if (this.state.type === 'election') {
				const url = 'https://hcapps.holycross.edu/faculty_elections_admin/available_elections?';
				const args = {
					election_id: this.state.id,
					email: this.state.email,
				};
				const query = queryString.stringify(args, { encode: false });
				const path = url + query;
				Axios({
					method: 'get',
					url: path,
					timeout: 5000,
					headers: { AUTHKEY: sessionStorage.getItem('FECaccessToken') },
				})
					.then((res) => {
						console.log('successfully queried election divisions');
						this.setGroups(res.data);
						sessionStorage.setItem('FECstatusList', JSON.stringify(res.data));
						this.setOffline(false);
						this.setIsLoaded(true);
					})
					.catch((error) => {
						console.error('error querying election divisions: ', error);
						this.setOffline(true);
					});
			}
			return true;
		}
	};

	castFinalBallot = async () => {
		const Body = {
			email: this.state.email,
			election_id: this.state.id,
		};
		const nomURL = 'https://hcapps.holycross.edu/faculty_elections_admin/finalize_nomination';
		const eleURL = 'https://hcapps.holycross.edu/faculty_elections_admin/finalize_vote';
		var path = '';
		if (this.state.type === 'nomination') {
			path = nomURL;
		} else if (this.state.type === 'election') {
			path = eleURL;
		}
		await Axios({
			method: 'post',
			url: path,
			timeout: 5000,
			headers: { AUTHKEY: sessionStorage.getItem('FECaccessToken') },
			data: Body,
		})
			.then((res) => {
				console.log('final ballot cast!', res.data);
				this.setOffline(false);
				if (res.data.result === 'failure') {
					alert('Something went wrong with your ballot: ' + res.data.message);
				}
			})
			.catch((error) => {
				console.error('error casting final ballot', error);
				this.setOffline(true);
			});
		this.getOpenElections();
		return true;
	};

	showNominations = (nominations) => {
		if (!(nominations === undefined)) {
			if (nominations.length > 0) {
				return (
					<HomepageList
						email={this.state.email}
						accessToken={this.state.accessToken}
						title="Current Nominations"
						type="nomination"
						list={this.state.nominations.nominations}
						callbackFromParent={this.setGroups}
						callbackName={this.setStatusTitle}
						setType={this.setType}
						setId={this.setId}
						setOffline={this.setOffline}
						setIsLoaded={this.setIsLoaded}
					/>
				);
			} else {
				return null;
			}
		} else {
			return null;
		}
	};

	showElections = (elections) => {
		if (!(elections === undefined)) {
			if (elections.length > 0) {
				return (
					<HomepageList
						email={this.state.email}
						accessToken={this.state.accessToken}
						title="Current Elections"
						type="election"
						list={this.state.elections.elections}
						callbackFromParent={this.setGroups}
						callbackName={this.setStatusTitle}
						setType={this.setType}
						setId={this.setId}
						setOffline={this.setOffline}
						setIsLoaded={this.setIsLoaded}
					/>
				);
			} else {
				return null;
			}
		} else {
			return null;
		}
	};

	showResults = (finished) => {
		if (!(finished === undefined)) {
			if (finished.length > 0) {
				return (
					<HomepageList
						email={this.state.email}
						accessToken={this.state.accessToken}
						title="Election Results"
						type="result"
						list={this.state.finished.elections}
						callbackFromParent={this.setResults}
						callbackName={this.setResultsTitle}
						setType={this.setType}
						setId={this.setId}
						setOffline={this.setOffline}
						setLeave={this.setLeave}
						setIsLoaded={this.setIsLoaded}
					/>
				);
			} else {
				return null;
			}
		} else {
			return null;
		}
	};

	showOffline = (offline) => {
		if (offline === true) {
			return (
				<p style={warningStyle}>
					There was a problem accessing election data at this time. Please try again later, or
					contact{' '}
					<a href="mailto: helpdesk-request@holycross.edu">helpdesk-request@holycross.edu</a>
					&nbsp;if the problem persists.
				</p>
			);
		} else {
			return null;
		}
	};

	googleResponse = async (response) => {
		const path = 'https://hcapps.holycross.edu/faculty_elections_admin/validate_token?token=';
		const token = response.credential;
		const url = path + token;
		await Axios({ method: 'get', url: url, timeout: 5000 })
			.then((res) => {
				if (res.data.result === 'success') {
					console.log('google login successful, user: ', res.data.email);
					this.setState({ email: res.data.email }, () => {
						sessionStorage.setItem('FECemail', res.data.email);
						this.setState({ accessToken: res.data.token }, () => {
							sessionStorage.setItem('FECaccessToken', res.data.token);
							this.setState({ isLoggedIn: true });
						});
					});
				} else {
					console.log('google login unsuccessful: ', res.data.message);
				}
			})
			.catch((error) => {
				console.error('error validating google ID token', error);
				this.setOffline(true);
			});
	};

	onFailure = (error) => {
		console.error('error logging in w/ google', error);
		const message = 'error logging in w/ google' + JSON.stringify(error);
		const url = 'https://hcapps.holycross.edu/faculty_elections_admin/log_message?message=';
		Axios({ method: 'get', url: url + message, timeout: 5000 })
			.then((res) => {
				console.log('successfully sent error message to backend');
			})
			.catch((error) => {
				console.error('error sending message to backend: ', error);
				this.setOffline(true);
			});
	};

	getOpenElections = () => {
		this.setState({ homeLoaded: 0 });
		const user = sessionStorage.getItem('FECemail');
		const nomURL =
			'https://hcapps.holycross.edu/faculty_elections_admin/open_nominations?email=';
		const eleURL = 'https://hcapps.holycross.edu/faculty_elections_admin/open_elections?email=';
		const resURL =
			'https://hcapps.holycross.edu/faculty_elections_admin/available_results?email=';
		var path = nomURL + user;
		Axios({
			method: 'get',
			url: path,
			timeout: 5000,
			headers: { AUTHKEY: sessionStorage.getItem('FECaccessToken') },
		})
			.then((res) => {
				console.log('successfully queried open nominations');
				this.setState({ nominations: res.data });
				this.setState({ homeLoaded: this.state.homeLoaded + 1 });
				this.setOffline(false);
			})
			.catch((error) => {
				console.error('error queying open nominations: ', error);
				this.setState({ offline: true });
			});
		path = eleURL + user;
		Axios({
			method: 'get',
			url: path,
			timeout: 5000,
			headers: { AUTHKEY: sessionStorage.getItem('FECaccessToken') },
		})
			.then((res) => {
				console.log('successfully queried open elections');
				this.setState({ elections: res.data });
				this.setState({ homeLoaded: this.state.homeLoaded + 1 });
				this.setOffline(false);
			})
			.catch((error) => {
				console.error('error queying open elections: ', error);
				this.setState({ offline: true });
			});
		path = resURL + user;
		Axios({
			method: 'get',
			url: path,
			timeout: 5000,
			headers: { AUTHKEY: sessionStorage.getItem('FECaccessToken') },
		})
			.then((res) => {
				console.log('successfully queried previous election results');
				this.setState({ finished: res.data });
				this.setState({ homeLoaded: this.state.homeLoaded + 1 });
				this.setOffline(false);
			})
			.catch((error) => {
				console.error('error queying previous elections: ', error);
				this.setState({ offline: true });
			});
	};

	handleLogout = async () => {
		const url = 'https://hcapps.holycross.edu/faculty_elections_admin/remove_token?email=';
		const path = url + sessionStorage.getItem('FECemail');
		await Axios({
			method: 'get',
			url: path,
			timeout: 5000,
			headers: { AUTHKEY: sessionStorage.getItem('FECaccessToken') },
		})
			.then((res) => {
				console.log('successfully logged user out, user: ', this.state.email);
			})
			.catch((error) => {
				console.error('error logging user out: ', error);
			});
		sessionStorage.removeItem('FECemail');
		sessionStorage.removeItem('FECaccessToken');
		sessionStorage.removeItem('FECdivTitle');
		sessionStorage.removeItem('FECresults');
		sessionStorage.removeItem('FECresultsTitle');
		sessionStorage.removeItem('FECid');
		sessionStorage.removeItem('FECballotTitle');
		sessionStorage.removeItem('FECstatusListTitle');
		sessionStorage.removeItem('FECballot');
		sessionStorage.removeItem('FECleave');
		sessionStorage.removeItem('FECtype');
		sessionStorage.removeItem('FECaudience_id');
		sessionStorage.removeItem('FECstatusList');
		this.setState({ accessToken: null });
		this.setState({ isLoggedIn: false });
	};

	componentDidMount() {
		if (sessionStorage.getItem('FECstatusList')) {
			this.setGroups(JSON.parse(sessionStorage.getItem('FECstatusList')));
		}
		if (sessionStorage.getItem('FECballot')) {
			this.setBallot(JSON.parse(sessionStorage.getItem('FECballot')));
		}
		if (sessionStorage.getItem('FECresults')) {
			this.setResults(JSON.parse(sessionStorage.getItem('FECresults')));
		}
		if (sessionStorage.getItem('FECleave')) {
			this.setLeave(JSON.parse(sessionStorage.getItem('FECleave')));
		}
		if (sessionStorage.getItem('FECstatusListTitle')) {
			this.setStatusTitle(sessionStorage.getItem('FECstatusListTitle'));
		}
		if (sessionStorage.getItem('FECresultsTitle')) {
			this.setResultsTitle(sessionStorage.getItem('FECresultsTitle'));
		}
		if (sessionStorage.getItem('FECtype')) {
			this.setType(sessionStorage.getItem('FECtype'));
		}
		if (sessionStorage.getItem('FECid')) {
			this.setId(sessionStorage.getItem('FECid'));
		}
		if (sessionStorage.getItem('FECballotTitle')) {
			this.setBallotTitle(sessionStorage.getItem('FECballotTitle'));
		}
		if (sessionStorage.getItem('FECdivTitle')) {
			this.setDivTitle(sessionStorage.getItem('FECdivTitle'));
		}
		if (sessionStorage.getItem('FECaudience_id')) {
			this.setAudience_id(sessionStorage.getItem('FECaudience_id'));
		}
		if (sessionStorage.getItem('FECemail')) {
			this.setEmail(sessionStorage.getItem('FECemail'));
		}
		if (sessionStorage.getItem('FECaccessToken')) {
			this.setState({ isLoggedIn: true });
			this.setAccessToken(sessionStorage.getItem('FECaccessToken'));
		}
	}

	render() {
		return (
			<GoogleOAuthProvider clientId={GOOGLE_AUTH_CLIENT_ID}>
				<Router basename={process.env.PUBLIC_URL}>
					<StyleRoot>
						<div className="d-flex flex-column h-100">
							{this.showOffline(this.state.offline)}
							<Header isLoggedIn={this.state.isLoggedIn} handleLogout={this.handleLogout} />
							<Switch>
								<Route
									exact
									path="/home"
									render={(props) => (
										<Breadcrumb>
											<BreadcrumbItem active>Home</BreadcrumbItem>
										</Breadcrumb>
									)}
								/>
								<Route
									exact
									path="/status"
									render={(props) => (
										<Breadcrumb>
											<BreadcrumbItem>
												<Link to="/home">Home</Link>
											</BreadcrumbItem>
											<BreadcrumbItem active>Status</BreadcrumbItem>
										</Breadcrumb>
									)}
								/>
								<Route
									exact
									path="/ballot"
									render={(props) => (
										<Breadcrumb>
											<LinkModal
												yesPath="/home"
												linkText="Home"
												title="Confirmation"
												body="Are you sure you would like to navigate away? Choices made will not be saved."
											/>
											<span style={{ color: '#6c757d' }}>&nbsp;&nbsp;/&nbsp;&nbsp;</span>
											<LinkModal
												yesPath="/status"
												linkText="Status"
												title="Confirmation"
												body="Are you sure you would like to navigate away? Choices made will not be saved."
											/>
											<span style={{ color: '#6c757d' }}>&nbsp;&nbsp;/&nbsp;&nbsp;</span>
											<BreadcrumbItem active>Ballot</BreadcrumbItem>
										</Breadcrumb>
									)}
								/>
								<Route
									exact
									path="/results"
									render={(props) => (
										<Breadcrumb>
											<BreadcrumbItem>
												<Link to="/home">Home</Link>
											</BreadcrumbItem>
											<BreadcrumbItem active>Results</BreadcrumbItem>
										</Breadcrumb>
									)}
								/>
							</Switch>

							<div className="flex-shrink-0 mt-3">
								<Switch>
									<Route
										exact
										path="/"
										render={(props) => (
											<React.Fragment>
												<Container>
													<Row>
														<Col className="mt-4">
															<h1 style={titleStyle}>
																Welcome to the Faculty Elections Application
															</h1>
															<p style={textStyle}>
																"Through participation on committees, faculty contribute to the
																formulation and execution of the academic policies of the College,
																an essential aspect of shared governance.”
															</p>
															<p style={textStyle}>
																&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-{' '}
																<i>Statutes of the Faculty</i>
															</p>
															<p style={textStyle}>
																Once an election or nomination opens, faculty members can come here
																to vote using either their PC or mobile device. Simply use your
																college provided gmail account to sign in and see which ballots are
																currently open to you or view the results of previous faculty
																elections.
															</p>
															<p style={textStyle}>
																Election results will be available once they have been verified by
																the Committee on Nominations and Elections.
															</p>
															<p style={textStyle}>
																For technical assistance with voting, please contact:{' '}
																<a href="mailto: helpdesk-request@holycross.edu">
																	helpdesk-request@holycross.edu
																</a>
																<br />
																For all other questions please contact the Committee on Nominations
																and Elections{' '}
																<a href="mailto: cne@holycross.edu">cne@holycross.edu</a>.
															</p>
														</Col>
													</Row>
													<Row>
														<Col
															style={{
																textAlign: 'center',
																marginBottom: '32px',
															}}
															md="12"
															lg={{ size: 6, offset: 3 }}
														>
															<h2 style={titleStyle}>
																Please use your Holy Cross gmail account to log in.
															</h2>
															<GoogleLogin
																onSuccess={(credentialResponse) => {
																	this.googleResponse(credentialResponse);
																}}
																onError={this.onFailure}
																containerProps={{
																	style: {
																		display: 'flex',
																		justifyContent: 'center',
																	},
																}}
															/>
														</Col>
													</Row>
												</Container>
												{sessionStorage.getItem('FECaccessToken') && <Redirect push to="/home" />}
											</React.Fragment>
										)}
									/>
									<Route
										exact
										path="/home"
										render={(props) => (
											<div>
												{sessionStorage.getItem('FECaccessToken') ? (
													<React.Fragment>
														<MyLoader load={this.getOpenElections} />
														<Container>
															{this.state.homeLoaded < 3 ? (
																<div style={spinnerStyle}>
																	<Loader
																		type="TailSpin"
																		color="#602d89"
																		height={128}
																		width={128}
																	/>
																</div>
															) : (
																<>
																	<Row>
																		<Col>
																			<h1 style={titleStyle}>
																				Welcome to the Faculty Elections Application
																			</h1>
																			<p style={textStyle}>
																				"Through participation on committees, faculty contribute to
																				the formulation and execution of the academic policies of
																				the College, an essential aspect of shared governance.”
																			</p>
																			<p style={textStyle}>
																				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-{' '}
																				<i>Statutes of the Faculty</i>
																			</p>
																			<p style={textStyle}>
																				Once an election or nomination opens, faculty members can
																				come here to vote using either their PC or mobile device.
																			</p>
																			<p style={textStyle}>
																				Election results will be available once they have been
																				verified by the Committee on Nominations and Elections.
																			</p>
																			<p style={textStyle}>
																				For technical assistance with voting, please contact:{' '}
																				<a href="mailto: helpdesk-request@holycross.edu">
																					helpdesk-request@holycross.edu
																				</a>
																				<br />
																				For all other questions please contact the Committee on
																				Nominations and Elections{' '}
																				<a href="mailto: cne@holycross.edu">cne@holycross.edu</a>.
																			</p>
																		</Col>
																	</Row>
																	<Row>
																		<Col md="12" lg={{ size: 8, offset: 2 }}>
																			{this.showNominations(this.state.nominations.nominations)}
																			{this.showElections(this.state.elections.elections)}
																			{this.showResults(this.state.finished.elections)}
																		</Col>
																	</Row>
																</>
															)}
														</Container>
													</React.Fragment>
												) : (
													<>
														<Redirect push to="/" />
													</>
												)}
											</div>
										)}
									/>
									<Route
										exact
										path="/status"
										render={(props) => (
											<div>
												{sessionStorage.getItem('FECaccessToken') ? (
													<React.Fragment>
														<Container>
															{this.state.isLoaded === false ? (
																<div style={spinnerStyle}>
																	<Loader
																		type="TailSpin"
																		color="#602d89"
																		height={128}
																		width={128}
																	/>
																</div>
															) : (
																<Row>
																	<Col md="12" lg={{ size: 6, offset: 3 }}>
																		<p style={textStyle}>{this.state.groups.rules}</p>
																		<p>
																			<b>
																				When you are finished, you must click on the "CAST BALLOT"
																				button to finalize your vote, otherwise your vote will not
																				be counted!
																			</b>
																		</p>
																		<StatusList
																			email={this.state.email}
																			title={this.state.statusTitle}
																			list={this.state.groups.audiences}
																			id={this.state.id}
																			callbackFromParent={this.setBallot}
																			callbackName={this.setBallotTitle}
																			callbackDiv={this.setDivTitle}
																			callbackAudience={this.setAudience_id}
																			callbackClearChoices={this.clearChoices}
																			callbackClearBallot={this.clearBallot}
																			castFinalBallot={this.castFinalBallot}
																			setLeave={this.setLeave}
																			setOffline={this.setOffline}
																			addBallotLoaded={this.addBallotLoaded}
																			clearBallotLoaded={this.clearBallotLoaded}
																		/>
																	</Col>
																</Row>
															)}
														</Container>
													</React.Fragment>
												) : (
													<>
														<Redirect push to="/" />
													</>
												)}
											</div>
										)}
									/>
									<Route
										exact
										path="/ballot"
										render={(props) => (
											<div>
												{sessionStorage.getItem('FECaccessToken') ? (
													<React.Fragment>
														<Container>
															{this.state.ballotLoaded < 2 ? (
																<div style={spinnerStyle}>
																	<Loader
																		type="TailSpin"
																		color="#602d89"
																		height={128}
																		width={128}
																	/>
																</div>
															) : (
																<Row>
																	<Col md="12" lg={{ size: 6, offset: 3 }}>
																		{this.state.ballot.statute && (
																			<p style={textStyle}><div className="content" dangerouslySetInnerHTML={{__html: this.state.ballot.statute}}></div></p>
																		)}
																		<p style={textStyle}>{this.state.ballot.rules}</p>
																		{this.state.ballot.statements && (
																			<Statements statements={this.state.ballot.statements} />
																		)}
																		<ElectionList
																			user={this.state.email}
																			title={this.state.ballotTitle}
																			divTitle={this.state.divTitle}
																			leave={this.state.leave}
																			list={this.state.ballot}
																			choices={this.state.choices}
																			callbackFromParent={this.setChoices}
																			markChoice={this.markChoice}
																			initChoice={this.initializeChoices}
																			saveChoices={this.saveChoices}
																			statusTitle={this.state.statusTitle}
																		/>
																		{! this.state.ballot.statute && (
																			<LeaveLegend list={this.state.leave} />
																		)}
																	</Col>
																</Row>
															)}
														</Container>
													</React.Fragment>
												) : (
													<>
														<Redirect push to="/" />
													</>
												)}
											</div>
										)}
									/>
									<Route
										exact
										path="/results"
										render={(props) => (
											<div>
												{sessionStorage.getItem('FECaccessToken') ? (
													<React.Fragment>
														<Container>
															{this.state.isLoaded === false ? (
																<div style={spinnerStyle}>
																	<Loader
																		type="TailSpin"
																		color="#602d89"
																		height={128}
																		width={128}
																	/>
																</div>
															) : (
																<Row>
																	<Col md="12" lg={{ size: 8, offset: 2 }}>
																		<h1 style={titleStyle}>Election Results:</h1>
																		<ResultsList
																			leave={this.state.leave}
																			results={this.state.results}
																		/>
																		<LeaveLegend list={this.state.leave} />
																	</Col>
																</Row>
															)}
														</Container>
													</React.Fragment>
												) : (
													<>
														<Redirect push to="/" />
													</>
												)}
											</div>
										)}
									/>
								</Switch>
							</div>
							<Footer />
						</div>
					</StyleRoot>
				</Router>
			</GoogleOAuthProvider>
		);
	}
}

const titleStyle = {
	fontFamily: 'Playfair',
	marginBottom: '2rem',
};

const textStyle = {
	fontFamily: 'Avenir',
};

const warningStyle = {
	fontFamily: 'Avenir',
	color: '#d9534f',
	marginBottom: '0px',
};

const spinnerStyle = {
	textAlign: 'center',
	marginBottom: '2rem',
};

export default App;
